'use client';

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Spinner } from '@/components/ui/spinner';

export const MP_PREFER_MANUAL_CARD_KEY = 'hzc_mp_prefer_manual_card';
export const IYZICO_PREFER_MANUAL_CARD_KEY = 'hzc_iyzico_prefer_manual_card';

export function getPreferManualCard(storageKey: string): boolean {
  try {
    return sessionStorage.getItem(storageKey) === '1';
  } catch {
    return false;
  }
}

export function setPreferManualCard(storageKey: string, value: boolean) {
  try {
    if (value) {
      sessionStorage.setItem(storageKey, '1');
    } else {
      sessionStorage.removeItem(storageKey);
    }
  } catch {
    // ignore
  }
}

export function SavedCardsLoadFailedDialog({
  open,
  onRetry,
  onPayWithCard,
  retrying,
}: {
  open: boolean;
  onRetry: () => void;
  onPayWithCard: () => void;
  retrying?: boolean;
}) {
  return (
    <Dialog open={open} onOpenChange={() => {}}>
      <DialogContent className="sm:max-w-md" onPointerDownOutside={(e) => e.preventDefault()}>
        <DialogHeader className="text-center sm:text-center">
          <DialogTitle className="text-lg text-gray-900">Kayıtlı kartlar yüklenemedi</DialogTitle>
          <DialogDescription className="text-sm text-gray-600 pt-2">
            Kayıtlı kartlarınıza şu an ulaşılamıyor. Tekrar deneyebilir veya kart bilgilerinizi
            girerek ödemeye devam edebilirsiniz.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="flex flex-col gap-2 sm:flex-col sm:space-x-0 mt-2">
          <Button
            type="button"
            className="w-full rounded-full h-11 bg-hzc_purple_500 hover:bg-hzc_purple_500"
            disabled={retrying}
            onClick={onRetry}
          >
            {retrying ? (
              <span className="inline-flex items-center gap-2">
                <Spinner className="size-5 text-white" />
                Deneniyor...
              </span>
            ) : (
              'Kartları listelemeyi tekrar dene'
            )}
          </Button>
          <Button
            type="button"
            variant="outline"
            className="w-full rounded-full h-11"
            disabled={retrying}
            onClick={onPayWithCard}
          >
            Kredi kartı bilgilerini girerek öde
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
